"use strict";

import Backbone from 'backbone';
import _ from 'underscore';

export default class TastypieModel extends Backbone.Model {
  base_url() {
    var temp_url = super.url();
    return (temp_url.charAt(temp_url.length - 1) == '/' ? temp_url : temp_url+'/');
  }

  url() {
    return this.base_url();
  }
}


/** WEBPACK FOOTER **
 ** ./static/js/onefinestay/backbone/models/TastypieModel.js
 **/